"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var React = require("react");
var FlexiblePageTemplate = /** @class */ (function (_super) {
    __extends(FlexiblePageTemplate, _super);
    function FlexiblePageTemplate(props) {
        var _this = _super.call(this, props) || this;
        var sections = props.data && props.data.sections ? props.data.sections : null;
        _this.state = { sections: sections };
        return _this;
    }
    FlexiblePageTemplate.prototype.render = function () {
        var sections = this.state.sections;
        return (React.createElement(Layouts.Theme, __assign({}, this.props), sections ? (React.createElement("div", { className: "py-2-4 bg-neutral" },
            React.createElement(next_components_1.ShopifyNext.Components.DynamicSections, __assign({}, this.props)))) : (React.createElement("div", { className: "w-full bg-neutral" },
            React.createElement("div", { className: "m-2-4 content-placeholder max-w-lg mx-auto", style: { height: "1000px" } })))));
    };
    return FlexiblePageTemplate;
}(React.Component));
exports.FlexiblePageTemplate = FlexiblePageTemplate;
